import getFirstFocusableElement from '../utils/getFirstFocusableElement'

let returnFocusElement: HTMLElement | null = null

// NOTE: this directive will not work for components with an initial loading state, as
// the element will not have focusable elements present in the DOM when the directive is mounted.
export default {
  mounted(el) {
    returnFocusElement = document.activeElement as HTMLElement
    const firstFocusableElement = getFirstFocusableElement(el)
    if (firstFocusableElement)
      firstFocusableElement.focus()
  },
  beforeUnmount() {
    returnFocusElement.focus()
    returnFocusElement = null
  },
}
